import { render, staticRenderFns } from "./AddUserToGroup.vue?vue&type=template&id=57172784&"
import script from "./AddUserToGroup.vue?vue&type=script&lang=js&"
export * from "./AddUserToGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports